export default __webpack_public_path__ + "static/Careers-2-bg-7c22423c4cb5cf07ca21eb9152e4889e.svg";